class MathRandomizer {
    static randomFromRange({ min, max }) {
        return Math.random() * (max - min) + min;
    }
}

export { MathRandomizer as M };
//# sourceMappingURL=mathRandomizer-15b806e5.js.map
